import { render, staticRenderFns } from "./BtnFixed.vue?vue&type=template&id=929a8216&scoped=true&"
var script = {}
import style0 from "./BtnFixed.vue?vue&type=style&index=0&id=929a8216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929a8216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/sly/Apps/simoni/client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
